import { StyledSx } from "src/types/StyledSx";

const BottomBasketStyled: StyledSx = {
  root: {
    display: { sm: "flex", md: "none" },
    flexDirection: "column",
    maxHeight: "70%",
    position: "fixed",
    bottom: "60px",
    width: "100%",
    zIndex: 1199,
    left: 0,
    overflow: "scroll",
    overflowX: "hidden",
    boxShadow: "0px -4px 4px rgba(15, 15, 15, 0.1)",
    "&.Mui-expanded": {
      margin: 0,
    },
  },
  rootSummary: {
    padding: 0,
    position: "sticky",
    top: "0",
    backgroundColor: "white",
    zIndex: 4,

    ".MuiAccordionSummary-content": {
      display: "flex",
      flexDirection: "column",
      margin: "20px 0",
    },
  },
  drawer: {
    height: 93,
    flexShrink: 0,
  },
  backdrop: {
    zIndex: 1100,
    backgroundColor: "rgba(16, 24, 57, 0.8)",
    overflow: "hidden",
  },
  orderTitle: {
    marginRight: 1.5,
  },
  countProduct: {
    marginTop: 10,
  },
  textDetail: {
    padding: 0,
  },
  detailContainer: {
    width: "100%",
  },
};

export default BottomBasketStyled;
